// extracted by mini-css-extract-plugin
module.exports = {"faq":"FAQ_faq__1xb65","title":"FAQ_title__1V991","faqInner":"FAQ_faqInner__2rBHD"};